"use client";

const TimelineArticle = ({
  date,
  subtitle,
  image,
  title,
  listItems,
  iconColor,
  selectedTitle,
  onSelectItem,
}) => {
  return (
    <article className="float-left mb-10 w-full">
      <time className="px-2.5 py-1.5 mb-2.5 ml-4 w-full">
      <span className="w-full text-base font-semibold text-2xl sm:text-[3rem] leading-7 text-left text-yellow-700 block mt-[13px]" >
  {date}
</span>

        <span className="w-full text-left text-neutral-500 block mt-5">
          {subtitle}
        </span>
      </time>

      <div className="relative">
        <div className="w-full sm:w-[500px] h-auto sm:h-[440px] mx-auto p-5 flex flex-col justify-between bg-neutral-700 border border-amber-300 rounded-3xl shadow-[rgba(0,0,0,0.1)_5px_6px_20px_10px]">
          <div className="w-full h-auto sm:h-[260px] overflow-hidden rounded-xl">
            <img
              decoding="async"
              alt=""
              src={image.src}
              className="w-full h-full object-cover mx-auto block"
              fetchPriority={image.fetchPriority}
            />
          </div>

          <div className="mt-3 w-full">
            <p className="text-base font-bold text-center text-zinc-50">
              {title}
            </p>
            <ul className="mt-2 space-y-1 text-sm leading-6 text-center text-gray-200">
              {listItems.map((item, index) => {
                const isSelected = selectedTitle === item;
                return (
                  <li
                    key={item}
                    onClick={() => onSelectItem(item)}
                    className={`cursor-pointer transition-all px-4 py-2 rounded-md
                      ${
                        isSelected
                          ? "bg-[rgb(239,199,94)] text-black font-semibold"
                          : "text-gray-200"
                      }
                    `}
                  >
                    {isSelected ? (
                      <span className="flex items-center gap-2 justify-center">
                        <span>{item}</span>
                        <span className="text-lg text-yellow-700">▶</span>
                      </span>
                    ) : (
                      item
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </article>
  );
};

export default TimelineArticle;
